import { render, staticRenderFns } from "./EvidenceSection.vue?vue&type=template&id=3a2b065e&scoped=true"
import script from "./EvidenceSection.vue?vue&type=script&lang=js"
export * from "./EvidenceSection.vue?vue&type=script&lang=js"
import style0 from "./EvidenceSection.vue?vue&type=style&index=0&id=3a2b065e&prod&lang=scss&scoped=true"
import style1 from "./EvidenceSection.vue?vue&type=style&index=1&id=3a2b065e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b065e",
  null
  
)

export default component.exports